import { PerkData } from 'api/get-perks';

import { getOverflowScrollStyle, useOverflowScroll } from 'hooks/use-overflow-scroll';

import * as S from './neighbourhood-perk.styled';
import { getImageUrl } from './utils';

interface NeighbourhoodPerkProps {
  data: PerkData;
}

export const NeighbourhoodPerk = ({ data }: NeighbourhoodPerkProps) => {
  const description = useOverflowScroll(data.description, 'vertical');

  return (
    <S.Container>
      <S.ImageContainer>
        <S.Image src={getImageUrl(data.image)} />
        {data.logo ? (
          <S.LogoContainer>
            <S.Logo src={getImageUrl(data.logo)} />
          </S.LogoContainer>
        ) : null}
        {data.tag ? <S.Tag>{data.tag}</S.Tag> : null}
      </S.ImageContainer>
      <S.InfoContainer>
        <S.Title>{data.name}</S.Title>
        <S.Description ref={description.containerRef}>
          <S.DescriptionText
            ref={description.textRef}
            $isScrolling={!!description.scroll}
            style={getOverflowScrollStyle(description.scroll)}
          >
            {data.description}
          </S.DescriptionText>
        </S.Description>
      </S.InfoContainer>
    </S.Container>
  );
};
